import moment from 'moment';
import mongoose from 'mongoose';
import api from '../../../App/socket';

export const readNextLead = (date, lead_id, where, isDeliveryRequested) => {
    if (!isDeliveryRequested) {
        const maxId = mongoose.Types.ObjectId.createFromTime(moment().subtract(10, 'minutes').valueOf() / 1000);

        return api.send({
            api: 'db',
            model: 'Lead',
            action: 'Read',
            options: {
                limit: 1,
                where: {
                    ...where,
                    _id: {
                        $gt: lead_id,
                        $lt: maxId,
                    },
                },
            },
        });
    }

    return api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            limit: 1,
            where: {
                ...where,
                transport_requested_date: {
                    $gt: date,
                },
            },
            order: {
                transport_requested_date: 1,
            },
        },
    });
};

export const readPreviousLead = (date, lead_id, where, isDeliveryRequested) => {
    if (!isDeliveryRequested) {
        return api.send({
            api: 'db',
            model: 'Lead',
            action: 'Read',
            options: {
                limit: 1,
                order: {
                    _id: -1,
                },
                where: {
                    ...where,
                    _id: {
                        $lt: lead_id,
                    },
                },
            },
        });
    }

    return api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            limit: 1,
            where: {
                ...where,
                transport_requested_date: {
                    $lt: date,
                },
            },
            order: {
                transport_requested_date: -1,
            },
        },
    });
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/read_next_prev_lead_request.js